// Externals
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
// Styling
import { ReactTooltipStyles } from "../styles";

const propTypes = {
  position: PropTypes.string,
  children: PropTypes.node.isRequired
};

const Tooltip = ({ position, children }) => {
  const node = useRef();
  const [isVisible, setState] = useState(false);
  const handleClick = ({ target }) => {
    if (node.current.contains(target)) {
      // inside click
      return;
    }
    // outside click
    setState(false);
  };

  useEffect(() => {
    // add when mounted
    document.addEventListener("mousedown", handleClick);
    // return function to be called when unmounted
    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, []);

  return (
    <div
      className="metaContainer-inner-2"
      data-testid="tooltip"
      ref={node}
      onClick={() => setState(!isVisible)}
    >
      {isVisible && (
        <div className="tooltipContent bottom" data-testid="tooltip-content">
          {children}
        </div>
      )}
    </div>
  );
};

Tooltip.defaultProps = {
  position: "right"
};

Tooltip.propTypes = propTypes;

export default Tooltip;
